/* eslint-disable import/no-anonymous-default-export */
export default {
  "exception.back": "Back to Home",
  "exception.403.title": "Sorry, you do not have access to this page",
  "exception.404": "404",
  "exception.404.title": "This link seems to no longer exist or you are lost",
  "exception.404.message":
    "Contact whoever sent you this link and ask them to verify it",
  "exception.500.title": "Sorry, the server is reporting an error",
};
